(function () {
  var wrap = document.querySelector('[data-sticky-atc-extended-wrap]');
  var floatingButton = document.querySelector('[data-sticky-atc-extended]');
  var realButton = document.querySelector('[data-product-add-to-cart]');

  if (!wrap || !floatingButton) {
    return;
  }

  floatingButton.addEventListener('click', function () {
    if (realButton) {
      realButton.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  });

  if (realButton && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
          wrap.setAttribute('data-sticky-atc-extended-hidden', '');
        } else {
          wrap.removeAttribute('data-sticky-atc-extended-hidden');
        }
      });
    });

    observer.observe(realButton);
  }

  document.addEventListener('variantChange', function (event) {
    var variant = event.detail && event.detail.variant;
    var available = !!(variant && variant.available);

    floatingButton.disabled = !available;
    floatingButton.textContent = available
      ? floatingButton.getAttribute('data-sticky-atc-extended-text')
      : floatingButton.getAttribute('data-sticky-atc-extended-sold-out-text');
  }, true);
})();
